import { call } from 'redux-saga/effects'
import { saga_act } from 'src/types'

import { saga_resolve_fpool } from './common.saga'

/**
 * Resolve fpool fastquote
 */
export function* saga_resolve_fpool_fastquote(action: saga_act): unknown {
  yield call(saga_resolve_fpool, action, true)
}
